__webpack_require__.p = "https://sogys.wassa-dev.com/";